import type { Factura } from "../services/facturas.api";

/** Intervalo de refresco mientras alguna factura sigue "En proceso" (esperando al SAT). */
export const REFRESCO_EN_PROCESO_MS = 10_000;

/**
 * Serie y folio fiscales del CFDI en una sola etiqueta ("A-123"). Si solo hay
 * uno de los dos se muestra ese; sin ninguno, "—".
 */
export function serieFolio(f: Pick<Factura, "serie" | "folio">): string {
  const serie = f.serie?.trim();
  const folio = f.folio?.trim();
  if (serie && folio) return `${serie}-${folio}`;
  return serie || folio || "—";
}

/**
 * Refresco de la sub-tabla de facturas: solo mientras alguna factura está "En
 * proceso" (el SAT aún no responde), para reflejar su estatus final sin
 * refrescar sin necesidad las que ya terminaron.
 */
export function intervaloRefrescoFacturas(facturas: readonly Pick<Factura, "estatus">[] | undefined): number | false {
  return facturas?.some((f) => f.estatus === "EnProceso") ? REFRESCO_EN_PROCESO_MS : false;
}
